@if (templates().length === 1) {
  <button type="button" class="row-print" (click)="print(templates()[0])">
    <mat-icon>print</mat-icon>
    {{ 'components.template-editor.print.print' | transloco }}
  </button>
} @else if (templates().length > 1) {
  <button type="button" class="row-print" [matMenuTriggerFor]="templateMenu">
    <mat-icon>print</mat-icon>
    {{ 'components.template-editor.print.print' | transloco }}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #templateMenu="matMenu" xPosition="before">
    @for (template of templates(); track template.id) {
      <button mat-menu-item type="button" (click)="print(template)">
        {{ template.text_template?.name }}
      </button>
    }
  </mat-menu>
}
